import { UberTermsMocks, CancelAccountTermsMocksDef } from '../../Mocks';
import { IMockProps, Mocks, MockServiceType, Utils } from '../../Core';
import { CommonContentTypes } from '../../Types';
import { CommonContentApi } from '../../Apis';
import { CommonContentRawRequest } from '../../Types/internals/CommonContent.types';
import { CommonContentInternalsTypes } from '../../Types/internals';

/** Mocks de Sucesso */
const mocksSuccess: IMockProps[] = [];

const { ENDPOINT_API_PATH } = CommonContentApi.definitions;

const getComonContentSuccess = (
  params: CommonContentRawRequest,
  response: CommonContentInternalsTypes.CommonContentRawResponse,
  xApiKey: string,
): IMockProps => {
  return {
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      params,
      headers: {
        [Utils.constants.HeadersType.xApiKey]: xApiKey,
        Channel: 'APP',
        API_VERSION: 2,
      },
    },
    configResponse: {
      status: 200,
      data: response,
    },
  };
};

mocksSuccess.push(
  getComonContentSuccess(
    UberTermsMocks.UBER_TERMS_RAW_REQUEST,
    UberTermsMocks.UBER_TERMS_RAW_RESPONSE,
    UberTermsMocks.UBER_API_KEY,
  ),
  getComonContentSuccess(
    CancelAccountTermsMocksDef.CANCEL_ACCOUNT_RAW_REQUEST,
    CancelAccountTermsMocksDef.CANCEL_ACCOUNT_TERMS_RAW_RESPONSE,
    CancelAccountTermsMocksDef.CANCEL_ACCOUNT_TERMS_API_KEY,
  ),
);

export const mocksService: MockServiceType<CommonContentTypes.CommonContentData>[] =
  mocksSuccess.map((request) => ({
    label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
    value: request.configRequest.params,
  }));

Mocks.getInstance().addAll(mocksSuccess);
